import { pass, fail, skip } from "../buildResult";
import { defineTest } from "../defineTest";

const isEmpty = (value) =>
  value === null || value === undefined || String(value).trim() === "";

export default defineTest("patient_time_spent_present", "Time Spent", ({ patient }) => {
  if (!patient?.patient_id) return skip("No patient record");

  if (isEmpty(patient.time_spent)) {
    return fail(
      "Time spent is empty",
      "time_spent is NULL for this patient in postgres"
    );
  }

  return pass(`Time spent: ${String(patient.time_spent).trim()}`);
});
